export function removeNaN(value: number, defaultValue: number) {
    if (value > 0) {
        return value
    } else {
        return defaultValue
    }
}

export function isHTMLTagSafe(str: string | number) {
    const regex = /^[^<>&#=;]*$/;
    return (typeof str === 'string' && regex.test(str)) || typeof str === 'number';
}

